import { bffFetch } from './utils';
import {
  trackingConsentsField,
  trackingConsentsFieldFragment,
  TrackingConsentMappingV1,
} from './tracking';

const getCMPDataQueryFields = `
  ${trackingConsentsField}
`;

const cmpDataQuery = {
  operationName: 'cmpData',
  query: `query cmpData {
    ${getCMPDataQueryFields}
  }

  ${trackingConsentsFieldFragment}`,
};

interface CMPData {
  trackingConsents: TrackingConsentMappingV1 | null;
}

export const fetchCMPData = async () => {
  return await bffFetch<CMPData>(cmpDataQuery);
};
